<template>
  <div>
    <div
      v-for="(field, index) of nestedFields"
      :key="index"
    >
      <label class="field-label">{{ field.label }}</label>
      <DynamicLayoutWrapper
        :template="getNestedTemplate(field.fields)"
        :questions="Object.values(field.fields)"
        :document-value="documentValue"
        :value="value && value[field.key]"
        :columns="2"
        :is-nested="true"
        class="mb-4 p-3 mt-2 border rounded-md"
      />
    </div>
    <DynamicLayoutWrapper
      :document-value="documentValue"
      :value="value"
      :template="template"
      :questions="flatFields"
      :columns="2"
    />
  </div>
</template>

<script>
import { computed, ref, toRefs } from '@nuxtjs/composition-api'
import DynamicLayoutWrapper from '../DynamicLayoutWrapper'
import useFieldActions from '@/composables/useFieldActions'

export default {
  components: { DynamicLayoutWrapper },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    documentValue: {
      type: Object,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { documentValue, question } = toRefs(props)

    const fields = computed(() =>
      Object.values(question.value.config.fields).map((questionField) => {
        const field = ref(questionField)
        const localValue = ref()

        const fieldValue = computed(() => {
          if (localValue.value !== undefined) return localValue.value
          if (props.value) {
            const valueFromNested =
              props.value[
                field.value.dataKey || field.value.questionId || field.value.key
              ]
            if (valueFromNested !== undefined) return valueFromNested
          }
          const valueFromDocument =
            props.documentValue[
              field.value.dataKey || field.value.questionId || field.value.key
            ]
          if (valueFromDocument !== undefined) return valueFromDocument
          return (
            field.value.config &&
            field.value.config.default &&
            field.value.config.default.value
          )
        })
        const onActionUpdate = (value) => {
          localValue.value = value
        }
        const { fieldWithChanges } = useFieldActions({
          field,
          formValue: documentValue,
          fieldValue,
          update: onActionUpdate,
          questions: field.value.fields
            ? Object.values(field.value.fields)
            : [],
        })
        return fieldWithChanges.value
      })
    )
    return {
      fields,
    }
  },
  computed: {
    nestedFields() {
      return this.fields
        .filter((field) => !field.hidden)
        .filter((field) => field.fields)
        .filter((field) => Object.values(field.fields).some((f) => !f.hidden))
    },
    flatFields() {
      return this.fields.filter((field) => !field.fields)
    },
    template() {
      return this.flatFields.map((q) => ({
        id: q.questionId || q.dataKey || q.key,
        type: 'question',
        hidden: q.hidden,
      }))
    },
  },
  methods: {
    getNestedTemplate(fields) {
      return Object.values(fields).map((q) => ({
        id: q.key,
        type: 'question',
      }))
    },
  },
}
</script>
